import * as preact from "preact";
import PureComponent from "./PureComponent";

// eslint-disable-next-line react/prefer-stateless-function
class Time extends PureComponent {
    render() {
        const { class: className, children: _children, type, ...timeProps } = this.props;

        const attrs = Object.entries(timeProps).map(([attr, val]) => `${attr}="${val}"`).join(" ");
        const timeElemHtml = `<${type} ${attrs}></${type}>`;

        return <span class={className} dangerouslySetInnerHTML={{ __html: timeElemHtml }}/>;
    }
}

export default Time;
